import { Component, OnInit } from '@angular/core';
import {Router,ActivatedRoute,Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router'
import { MasterService,AttendanceService,HrmsService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-manbatch',
  templateUrl: './manbatch.component.html',
  styleUrls: ['./manbatch.component.scss'],
   providers:[MasterService,AttendanceService]
})
export class ManbatchComponent implements OnInit {

  sections:any=[];
       tag:any;
       classes:any=[];
       attcordata:any=[];
       arrsubjects:any=[];
       fmodel:any={clid:'0',secid:'0',subid:'0',prid:'0',atscope:'Individual',cbclid:'0'};
       attdata:any=[];
       attdatacmb:any=[];
       arrper:any=[];
       attcordetdata:any=[];
       arrcnmcls:any=[];
       arrcnmcls1:any=[];
       arrcourse:any=[];
       oprtype:any='';
       tabledata: any = {};
       objclass:any={};
       arrstulst:any=[];
       fmodel1:any={};
       cmodel:any={};
       cbmodel:any={};
       crpmodel:any={};
       objcbcl:any={};
       objvhead:any={};
       arrcmbdet:any=[];
       msgexist="";
       rmkh="";
       classeslist:any=[];
       corclasses:any=[];
       attcmbcordata:any=[];
       corsections:any=[];
       corsubjects:any=[];
       subjectslist:any=[];
       arrstaff:any=[];
       showload:any="no";
       showsms:any='no';
       arrbatch:any=[];
       modalOptions:NgbModalOptions;
       private modalRef: NgbModalRef;
       arratscope:any=[{name:'Individual'}];
       //arratscope:any=[{name:'Individual'}];
       arropt:any=[{name:'Yes'},{name:'No'}];
   
       dropdownList = [];
       selectedItems = [];
       dropdownSettings:IDropdownSettings = {singleSelection: false,
         idField: 'stuid',
         textField: 'stunm',
         selectAllText: 'Select All',
         unSelectAllText: 'UnSelect All',
         itemsShowLimit: 0,
         allowSearchFilter: true};
    arflstudent: any;
    arreval: any;
    selemp: any;
    objmnrts: any;
    arrcnmcls11: any;
  arremp: any;
  arremp1: any[];
  objsubalot: any={};
  arrallocations: any;
       constructor(private http: HttpClient,private aservice:AttendanceService, private mservice: MasterService,private modalService: NgbModal,private router: ActivatedRoute,private hservice:HrmsService) { 
  
        // console.log(this.router.url);
        console.log(this.router.snapshot.url[0].path);

  
  
       }
     
        getmenuinfo(mid) {
      this.mservice.getmenuinfo(mid)
      .subscribe(
       resultArray =>
       { 
        console.log('menuinfo',resultArray);
        this.objmnrts=resultArray;
        this.mascourse();
         //this._postsArray = resultArray;
        // this.formatmenudata(resultArray);
     // console.log('menus',JSON.stringify(resultArray));
      }
  ,
       error => console.log("Error :: " + error)
   )
  }
       ngOnInit(): void {
        console.log("init called");
        this.getmenuinfo(this.router.snapshot.url[0].path);
         
         
         
        this.combinedclass1();
        this.getclasses();
        this.massection();
        
       }
   
     
       opentest(content,obj) {
         debugger
         this.fmodel1.cbclid=obj.cbclid;
         this.getclass(obj.clid);
         this.selbatch();
         this.getstuforcmb();
         this.getattcmbdet(this.fmodel1.cbclid);
         this.modalOptions = {
           backdrop:'static',
           backdropClass:'customBackdrop',
           size:'lg'
           
          
         }
         this.modalRef=this.modalService.open(content,this.modalOptions);
         
         this.modalRef.result.then((result) => {
        
              
           }, (reason) => {
               
           });
       }

          getclass(clid)
       {
   
        //  console.log(this.selectedItems);
   this.classes= this.classeslist.filter(
  (product) => product.clid === clid
);
this.fmodel1.clid=this.classes[0].clid;
       }
       
       addstudents()
       {
   
         console.log(this.selectedItems);
       }
     
 
       massection() {
         this.mservice.massection()
             .subscribe(
             resultArray => {
                 console.log('getdashcounts', resultArray);
                 this.sections = resultArray;
                //  this.fmodel.clid=resultArray[0].clid;
                 this.fmodel1.scid=resultArray[0].scid;
                //  this.cmodel.clid=resultArray[0].clid;
                
                
             },
             error => console.log("Error :: " + error)
             )
       }
   
      
   
      
   
      
   
      
     
   
      
      
   
       
   
       mascourse() {
           this.mservice.mascourse()
               .subscribe(
               resultArray => {
                   console.log('getdashcounts', resultArray);
                   this.arrcourse = resultArray;
                   this.fmodel.crid=resultArray[0].crid;
                   this.fmodel1.crid=resultArray[0].crid;
                   this.cmodel.crid=resultArray[0].crid;
                   this.crpmodel.crid=resultArray[0].crid;
                   
               },
               error => console.log("Error :: " + error)
               )
         }
   
   
         getclasses() {
           debugger
           this.mservice.masclass()

               .subscribe(
               resultArray => {
                   console.log('getdashcounts', resultArray);
                   this.classeslist = resultArray;
                   this.objclass.clid=resultArray[0].clid;
                  //  this.subjectmas();
                   
               },
               error => console.log("Error :: " + error)
               )
         }
   
   
         subjectmas(clid) {
           this.mservice.getclasssub(clid)
               .subscribe(
               resultArray => {
                   console.log('getdashcounts', resultArray);
                   this.subjectslist = resultArray;
                  
               },
               error => console.log("Error :: " + error)
               )
         }
   
          
    getstaff() {
    this.hservice.getemployes()
        .subscribe(
        resultArray => {
            console.log('getlibdepartment', resultArray);
            
          var activeemps   = resultArray.emplst.filter(function(arr)
            {
        
              return arr.emstatus=='Active';
            });
            this.arremp= activeemps.map( o => { return { emid: o.emid, emnm: o.emnm} });
           
            
        },
        error => console.log("Error :: " + error)
        )
  }

   filteremp(event) {
    //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
    let filtered: any[] = [];
    let query = event.query;
    

    this.arremp1 = this.arremp.filter(item => {
      
      const nameMatches = item.emnm.toLowerCase().includes(query.toLowerCase());
     
      return nameMatches ; 
    });
  }

     onDropDownClick(event: any) {
    this.arremp1 = this.arremp; // Show the full list

    // Manually toggle the dropdown visibility if needed, as default behavior can vary
    event.originalEvent.preventDefault();
    event.originalEvent.stopPropagation();

    // if (this.autoCompleteComponent.overlayVisible) {
    //   this.autoCompleteComponent.hide();
    // } else {
    //   this.autoCompleteComponent.show();
    // }
  }
      
  
          combinedclass1() {
         debugger
           this.mservice.combinedclass_new()
               .subscribe(
               resultArray => {
                   console.log('getdashcounts', resultArray);
                   if (resultArray != undefined)
                   {
                   this.arrcnmcls11 = resultArray;
                  //  this.fmodel.cbclid=resultArray[0].cbclid;
                  //  this.crpmodel.cbclid=resultArray[0].cbclid;
                  //  this.cbmodel.cbclid=resultArray[0].cbclid;
                   }
                  // this.oncmbclasschange();
                  //  this.getclasses();
                   // this.masperiod();
               },
               error => console.log("Error :: " + error)
               )
         }
   
   
        
   
       subjects(clid,crid) {
           this.mservice.subjectsrolewise(0,0,clid,'asaa',crid)
               .subscribe(
               resultArray => {
                   console.log('getdashcounts', resultArray);
                   this.arrsubjects = resultArray;
                   this.corsubjects = resultArray;
                   this.fmodel.subid=resultArray[0].suid;
                 
                  
               },
               error => console.log("Error :: " + error)
               )
         }
       
    
   
     openclass(content,objdata,cmd) {
   
       
       if(cmd=='insclh')
       {
         this.objclass={};
        
         
         this.objclass.cbclid=0;
         this.objclass.cbclcd='';
         this.objclass.cbclnm='';
         this.objclass.active='Yes';
         this.objclass.oprtype='insclh';
        
   
       }
   
       else if(cmd=='updclh')
       {
         this.objclass=objdata;
         this.objclass.oprtype='updclh';
       }
       
       this.modalOptions = {
         backdrop:'static',
         backdropClass:'customBackdrop',
         size:'sm'
        
        
       }
       this.modalRef=this.modalService.open(content,this.modalOptions);
       
       this.modalRef.result.then((result) => {
      
            
         }, (reason) => {
             
         });
     }
     
   
     saveclassdetails()
     {
   
   
       console.log('savedetails',this.objclass);
       this.mservice.savecmbclass_new(this.objclass)
   .subscribe(result => {
      alert(result.message);
      
   if(result.status=='Success')
   {
     let localmodref=this.modalRef;
   localmodref.close();
   //this.Refreshsummary();
   this.combinedclass1();
   
   }
   
   
   else{
   
   
   }
      
   
     
       
   }, error => alert('error in connection')
   );
     }
   
     getstuforcmb() {
       this.mservice.getstuforcmb(this.fmodel1)
           .subscribe(
           resultArray => {
               console.log('getdashcounts', resultArray);
               this.arrstulst = resultArray.arrstulst;
               // this.fmodel.cbclid=resultArray[0].cbclid;
           },
           error => console.log("Error :: " + error)
           )
     }
   
     selbatch()
   {
     debugger
     this.mservice.selbatch()
     .subscribe(
     resultArray =>{
       //console.log('sub-result', resultArray);
       this.arrbatch=resultArray;
       this.fmodel1.baid=resultArray[0].baid;
       //this.objfilt.baid=resultArray[0].baid;
       },
   error => console.log("Error :: " + error)
   )
   }
     savecbmclassd() {
       debugger
      
       this.aservice.savecbmclassd(this.fmodel1,this.selectedItems)
            .subscribe(resultArray => {
               console.log('ret-loop', resultArray);
     //var cbclid=this.fmodel1,cbclid
               alert(resultArray.message);
               if(resultArray.status=='Success')
               {
                 this.getattcmbdet(this.fmodel1.cbclid);
               this.getstuforcmb();
               this.selectedItems=[];
               }
           }, error =>
               alert('error in connection')
           );
     }
   
     getattcmbdet(cbclid) {
       this.aservice.getattcmbdet(cbclid)
           .subscribe(
           resultArray => {
               console.log('getdashcounts', resultArray);
               this.arrcmbdet = resultArray;
               
           },
           error => console.log("Error :: " + error)
           )
     }
   
     delcbmclassd(rid) {
       debugger
      
       if (confirm("Are you sure you want to delete ?"))
       this.aservice.delcbmclassd(rid)
            .subscribe(resultArray => {
               console.log('ret-loop', resultArray);
     //var cbclid=this.fmodel1,cbclid
               alert(resultArray.message);
               if(resultArray.status=='Success')
               {
                 this.getattcmbdet(this.fmodel1.cbclid);
               this.getstuforcmb();
               this.selectedItems=[];
               }
           }, error =>
               alert('error in connection')
           );
     }
  
  onbatchchange(crid)
  {
    debugger
    var selbatch=this.arrcnmcls11.filter(item=>item.cbclid==crid);
    var clid=selbatch[0].clid;
    this.subjectmas(clid);
  }
       openallocation(content) {
         debugger
         this.objsubalot={};
          this.objsubalot.oprtype='insert';
          this.objsubalot.altype='Batch';
         var clid=this.arrcnmcls11[0].clid;
         this.objsubalot.crid=this.arrcnmcls11[0].cbclid;
         this.objsubalot.clid=0;
         this.objsubalot.rid=0;
         this.objsubalot.scid=0;
         this.subjectmas(clid);

        //  this.getclass(obj.clid);
        //  this.selbatch();
        //  this.getstuforcmb();
        //  this.getattcmbdet(this.fmodel1.cbclid);
         this.modalOptions = {
           backdrop:'static',
           backdropClass:'customBackdrop',
           size:'md'
           
          
         }
         this.modalRef=this.modalService.open(content,this.modalOptions);
         
         this.modalRef.result.then((result) => {
        
              
           }, (reason) => {
               
           });
       }

       onallotclick()
       {
this.getstaff();
this.gethrsuballocation();
       }

       gethrsuballocation() {
  // this.atltype="Subject";
  this.hservice.hrbatchallocation()
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          this.arrallocations = resultArray;
          
         
      },
      error => console.log("Error :: " + error)
      )
}

  onpubselectEvent(item) {
    //alert('hi');
        console.log('item',item);
        this.objsubalot.emid=item.emid;
        //this.selmember=item;
        //this.getissuedbookinfocnts(item.id);
      //  this.getissueddetails();
        // do something with selected item
      }

          savealotdetails()
{

  console.log('alotdet',this.objsubalot);

  if(this.objsubalot.suid=='0' || this.objsubalot.suid==undefined)
  {
    alert('please choose subject');
  }

  else if(this.objsubalot.emid=='' || this.objsubalot.emid==undefined)
  {
    alert('please choose teacher');
  }
  else{
  this.hservice.savehrmsubalot(this.objsubalot)
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          alert(resultArray.message);

          if(resultArray.status=='success')
{
  let localmodref=this.modalRef;
localmodref.close();

this.gethrsuballocation();


}
          
         
      },
      error => console.log("Error :: " + error)
      )
    }
 // console.log('selemp',this.selemp.emid);
}



deleteallocation(obj)
{

  console.log(obj);
if(confirm("Are you sure,you wan't to delete ?"))
{
  let pstvar=obj;
  pstvar.oprtype='delete';

  this.hservice.savehrmsubalot(pstvar)
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          alert(resultArray.message);

          if(resultArray.status=='success')
{
  
this.gethrsuballocation();
  

}
          
         
      },
      error => console.log("Error :: " + error)
      )
}}
         
     }
   
